import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const getAllVideoDataPoints = (limit, lastTime, callback) => {
  return async (dispatch) => {
    if (lastTime) {
      dispatch({
        type: 'FETCHING_ALL_VIDEO_DATA_POINTS_WITH_PAGINATION',
      });
    } else {
      dispatch({ type: 'FETCHING_ALL_VIDEO_DATA_POINTS' });
    }
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.get(`/ads/data-points`, {
            params: {
              'request-id': reqId,
              // status: status,
              limit: limit,
              lastTime: lastTime,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          // console.log(response.data);
          if (response.status === 200) {
            if (lastTime) {
              await dispatch({
                type: 'ADD_DATA_POINTS_TO_ALL_DATA_POINTS',
                payload: {
                  dataPoints: response?.data,
                  lastTime:
                    response?.data?.[response?.data?.length - 1]?.createdOn,
                },
              });
            } else {
              await dispatch({
                type: 'FETCHING_ALL_VIDEO_DATA_POINTS_DONE',
                payload: {
                  dataPoints: response?.data,
                  lastTime:
                    response?.data?.[response?.data?.length - 1]?.createdOn,
                },
              });
            }
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'FETCHING_ALL_VIDEO_DATA_POINTS_FAILED',
              payload: `Failed to fetch video data points`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'FETCHING_ALL_VIDEO_DATA_POINTS_FAILED',
            payload: `Failed to fetch video data points`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'FETCHING_ALL_VIDEO_DATA_POINTS_FAILED',
        payload: `Failed to fetch video data points`,
      });
    }
  };
};

export default getAllVideoDataPoints;
